import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-up-left', 'IconChevronUpLeft', [["path",{"d":"M8 16v-8h8","key":"svg-0"}]]);